<template>
  <div >
    <v-card flat :color="globalColorC" >
        <v-container class="pt-2" >
            <v-card-title class="text-center justify-center py-6">
                <h1 class="font-weight-bold display-3 salmonOrange--text">
                    {{globalLanguage.pricingTitle}}
                </h1>
            </v-card-title>

        </v-container>
    </v-card>

    <v-card flat >
        <v-container class="pt-2" >
            <v-select
                v-model="selectGuidance"
                :items="itemGuidance"
                item-text="text"
                item-value="type"
                :label="globalLanguage.pricingGuidance"
                persistent-hint
                return-object
                single-line
            ></v-select>

            <v-expansion-panels popout v-if="showAll">
                <v-expansion-panel
                v-for="(item,i) in allItemsData"
                :key="i"
                >
                <v-expansion-panel-header>{{item.type}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                    Package
                                    </th>
                                    <th class="text-left">
                                    Price
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(packageItem,j) in item.package"
                                    :key="j"
                                >
                                    <td>{{ packageItem.name }}</td>
                                    <td>{{ packageItem.price }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-container>
    </v-card>

  </div>
  
</template>

<script>

import PRICINGBM from "../languageJSON/pricingBm.json"
import PRICINGENG from "../languageJSON/pricingEng.json"

export default {
  name: 'Pricing',
  props: ['globalColorA','globalColorB',"globalColorC","globalLanguage"],
  data () {
    return {
        items : [],
        selectGuidance : {},
        itemGuidance : [],
        showAll : false,
        allItemsData : [],
    }
  },

  watch:{
    globalLanguage()
    {
        this.addPricing()
    },
    selectGuidance()
    {
        if(this.selectGuidance.type == "Manual")
        {
            this.showAll = false
        }
        else if(this.selectGuidance.type == "Auto")
        {
            this.showAll = true
            this.allItemsData =  this.items.DataSelection
        }
    }
  },

  mounted()
  {
    this.addPricing()
  },

  methods: 
  {
    addPricing()
    {
        if(this.globalLanguage.selectedLanguage == "eng")
        {
            this.items = PRICINGENG
        }
        else if(this.globalLanguage.selectedLanguage == "bm")
        {
            this.items = PRICINGBM
        }

        this.addGuidance()
        
    },

    addGuidance()
    {
        this.itemGuidance =  this.items.selectionGuidance
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Pricing.vue